import { useQuery, useMutation } from '@tanstack/react-query';
import { SecurityService } from '../../services/security/security.service';
import { useAuthStore } from '../../stores';
import { changePortalPassword } from '../../services/auth/portal-auth.service';
import { changePortalUsername } from '../../services/auth/portal-auth.service';
export const MFA_QUERY_KEYS = {
    setup: ['mfa', 'setup'],
};
export const useSetupMfa = () => {
    const token = useAuthStore((state) => state.accessToken);
    return useQuery({
        queryKey: MFA_QUERY_KEYS.setup,
        queryFn: SecurityService.setupMfa,
        enabled: !!token,
        refetchOnWindowFocus: false,
        retry: 2, // Coba lagi 2x jika gagal
        staleTime: 0,
        gcTime: 0,
    });
};
export const useEnableMfa = (options) => {
    return useMutation({
        mutationFn: (payload) => SecurityService.enableMfa(payload),
        ...options,
    });
};
/**
 * useDisableMfa
 * Mutation untuk menonaktifkan MFA dengan verifikasi password.
 */
export const useDisableMfa = (options) => {
    return useMutation({
        mutationFn: (password) => SecurityService.disableMfa(password),
        ...options,
    });
};
/**
 * useChangePassword
 * Mutation untuk mengubah password akun.
 */
export const useChangePassword = (options) => {
    return useMutation({
        mutationFn: (payload) => SecurityService.changePassword(payload),
        ...options,
    });
};
/**
 * usePortalChangePassword
 * Mutation untuk mengubah password akun bagi pengguna portal (Nasabah/Siswa).
 */
export const usePortalChangePassword = (options) => {
    return useMutation({
        mutationFn: (payload) => changePortalPassword(payload),
        ...options,
    });
};
/**
 * usePortalChangeUsername
 * Mutation untuk mengubah username (user_cms) akun bagi pengguna portal.
 */
export const usePortalChangeUsername = (options) => {
    return useMutation({
        mutationFn: (payload) => changePortalUsername(payload),
        ...options,
    });
};
